import PropTypes from 'prop-types';
import React from 'react';
import {
  MARKET_DATA_HEALTH_STATUS,
  normalizeMarketDataHealthStatus,
} from '../../../../../../utils/marketDataHealth';
import style from './MarketDataHealthDot.module.css';

const healthPresentation = {
  [MARKET_DATA_HEALTH_STATUS.HEALTHY]: {
    className: style.healthy,
    label: 'Market data healthy',
  },
  [MARKET_DATA_HEALTH_STATUS.DEGRADED]: {
    className: style.degraded,
    label: 'Market data degraded',
  },
  [MARKET_DATA_HEALTH_STATUS.UNAVAILABLE]: {
    className: style.unavailable,
    label: 'Market data unavailable',
  },
};

export const getMarketDataHealthPresentation = (status) => {
  const normalizedStatus = normalizeMarketDataHealthStatus(status);
  return healthPresentation[normalizedStatus] ?? null;
};

export const MarketDataHealthDot = ({ status }) => {
  const presentation = getMarketDataHealthPresentation(status);
  if (!presentation) return null;

  return (
    <span
      aria-label={presentation.label}
      className={`${style.dot} ${presentation.className}`}
      role="img"
      title={presentation.label}
    />
  );
};

MarketDataHealthDot.propTypes = {
  status: PropTypes.string,
};
